export default __webpack_public_path__ + "static/mamda-mcma-252071b2cf53348d7ef359dd5fa23fb5.png";